export default "__VITE_ASSET__DPAK2SVG__"